/**
 * Fleet Edit Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.fleetEditFormatter = function(value, row) {
    let html = '';
    html += '<a href="/fleet/edit/'+row.type_id+'/'+row.id+'" class="action-custom action-custom-edit">';
    html += '<span class="fa fa-pencil"></span>';
    html += '</a>';
    return html;
};
